export default {
  methods: {
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else if (typeof this.form[key] === 'boolean') {
          this.form[key] = !this.form[key];
        } else if (typeof this.form[key] === 'number') {
          this.form[key] = 0;
        } else {
          this.form[key] = '';
        }
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/clearForm.js